export const ASSETS_PROFILE = "assets/profile/"
export const ASSETS_CLIENT_RECEIPT = "assets/client_receipt/"
